import { Injectable, OnDestroy, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs/internal/Subject';
import { Subscription } from 'rxjs/internal/Subscription';
import { timer } from 'rxjs/internal/observable/timer';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Injectable()
export class OnBoardingService implements  OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    private getLocalStorageValue = new BehaviorSubject<boolean>(false);

    updateLocalStorageState(value: boolean) {
        this.getLocalStorageValue.next(value);
    }
    public get getUpdatedLocalStorageValue(): Observable<boolean> {
        return this.getLocalStorageValue.asObservable();
    }

    public ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();

        //destroy the one second timer subject
        this.getLocalStorageValue.next(false);
        this.getLocalStorageValue.complete();
    }
}